import Vue from 'vue'
import App from './App.vue'
import router from "./router/index.js"
import ElementUI from "element-ui"
import store from "./store/index.js"

import './assets/css/style.css'

//动画
import VueParticles from 'vue-particles'
Vue.use(VueParticles)

import 'element-ui/lib/theme-chalk/index.css'
// 引入水印文件地址
import watermark from './util/watermark.js'
Vue.prototype.$watermark = watermark

//所有api挂载
import axios from "axios"
import qs from "qs"
import api from "./request/apis.js"
Vue.prototype.$axios = axios;
Vue.prototype.$qs = qs;
Vue.prototype.$api = api;

//挂载公共方法
import util from "./common/store/util.js"
Vue.prototype.$util = util;

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(ElementUI)
Vue.use(router);
Vue.use(VueQuillEditor)

Vue.config.productionTip = false

Vue.directive("permit", {
    inserted(el, binding) {
        const permitArr = store.state.permitArr || [];
        if (binding.value && !permitArr.includes(binding.value)) {
            el.parentNode.removeChild(el);
        }
    },
});

Vue.prototype.checkAuth = (url) => {
    if(!url){
        return true;
    }
    const permitArr = store.state.permitArr || [];
    return permitArr.includes(url);
}

new Vue({
	render: h => h(App),
	router,
	store,
    beforeCreate() {
        Vue.prototype.$bus = this;
    }
}).$mount('#app')